import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'find'
})
export class ArrayFindPipe implements PipeTransform {

  transform<T>(value: T[], findBy: any, excludeBy?: any): T {
    if (!value) return null;
    return value.find(row => {

      if (findBy) {
        for (const key of Object.keys(findBy)) {
          if (findBy[key] !== row[key]) {
            return false;
          }
        }
      }

      if (excludeBy) {
        for (const key of Object.keys(excludeBy)) {
          if (excludeBy[key] === row[key]) {
            return false;
          }
        }
      }

      return true;

    });
  }

}
